// extracted by mini-css-extract-plugin
export default {"highlightText":"HighlightText_highlightText__bAbAz"};